import type {
  PlanbookCalendar,
  PlanbookCalendarDateDefault,
  PlanbookDateAnnotation,
} from "@shared/models/planbook"
import ObjectId from "@shared/util/object-id-gen"
import map from "lodash-es/map"
import { findPlanbookDatesOff } from "../../lib/dates-off-calculator"
import type { RCAttributes } from "../rotation-calendar/create-attributes"

export function generatePlanbookCalendar(opts: {
  rotationCalendarAttributes: RCAttributes
  dateAnnotations: Array<PlanbookDateAnnotation>
}): PlanbookCalendar {
  let semester = opts.rotationCalendarAttributes.semesters[0]
  let dates = map(
    opts.rotationCalendarAttributes.rotations,
    (rotation): PlanbookCalendarDateDefault => {
      return {
        id: `${semester.id}:${rotation.id}`,
        type: "planbook-date-default",
        attributes: {
          cardStackId: ObjectId.create(),
          semesterId: semester.id,
          rotationId: rotation.id,
        },
      }
    }
  )
  let datesOff = findPlanbookDatesOff(opts.dateAnnotations)
  return { dates, dateAnnotations: opts.dateAnnotations, datesOff, version: 1 }
}
